/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  @service
  router;

  afterModel() {
    super.afterModel(...arguments);

    // Redirect to the first subject in the list, so that there's content to display.
    let params = this.paramsFor('group');
    let subjectId = this.controllerFor('group/insights/assessments').get(
      'subjects.firstObject.id',
    );
    this.router.transitionTo(
      'group.insights.assessments.progress.subject',
      params.group_id,
      subjectId,
    );
  }
}
